import React, { useState } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import View from '../../components/bantrab/view'
import { getBaseViewInfo } from '../../components/bantrab/view/functions'
import { getResources } from '../../api/bantrab'
import { RESOURCES_LIST_QUERY as ITEMS_LIST_QUERY } from '../../api/bantrab/queries'
// import { useBreakpoint } from '../../hooks/breakpoint'
import Header from '../../components/bantrab/resources/listing/kinds/header'
import List from '../../components/bantrab/resources/listing/kinds/list'
import Breadcrumb from '../../components/bantrab/resources/listing/kinds/breadcrumb'
import { KIND_AUDIO } from '../../components/bantrab/resources/constants'

import Button from '../../components/bantrab/button'

const ITEMS_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_BANTRAB_RESOURCES_PER_PAGE_ON_LISTING)

async function getServerSideProps () {
  const { head, navbar, footer } = await getBaseViewInfo()

  let resources = await getResources({
    ...ITEMS_LIST_QUERY,
    limit: ITEMS_PER_PAGE,
    kind: KIND_AUDIO
  })
  resources = await resources.json()

  // https://crehana-bantrab-backend.hackspace.pe/api/v1/cms/pages/?type=resources.ResourcesEntryPage&kind=video&fields=*

  const body = [
    // {
    //   type: 'resourceByKind',
    //   items: resources
    // },
    //   // icon: category === 'document' ? Download : category === 'audio' ? Podcast : Ebook,
    //   title: category === 'document' ? 'Descargables' : category === 'audio' ? 'Podcast' : 'eBooks',
    //   text: category === 'Inspírate con otras marcas y tiendas que utilizan Aplazame para aumentar sus ventas a través de la financiación' ?
    //     Download : category === 'De cero a héroe en eCommerce con los informes y guías de expertos.' ?
    //       Podcast : 'Sesiones cortas y al grano con temas calientes de tu sector.',
    //   items: childrenPages.items.filter(item => item.kind === category),
    {
      type: 'header',
      value: {
        title: 'Podcast',
        text: 'De cero a héroe en eCommerce con los informes y guías de expertos.',
        resourceKind: 'audio'
      }
    },
    {
      type: 'resources',
      value: {
        resources: resources
      }
    }
  ]

  return {
    props: {
      head,
      navbar,
      body,
      footer
    }
  }
}

const Home = ({ head, navbar, body, footer }) => {
  // const breakpoint = useBreakpoint()

  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(0)
  const [innerResources, setInnerResources] = useState(body[1].value.resources)

  const fetchResources = async _ => {
    setIsLoading(true)

    const offset = get(innerResources, 'items', []).length
    let fetchedResources = await getResources({
      ...ITEMS_LIST_QUERY,
      offset: offset,
      limit: ITEMS_PER_PAGE,
      kind: KIND_AUDIO
    })
    fetchedResources = await fetchedResources.json()

    const updatedResources = { ...innerResources }
    updatedResources.meta = {
      ...updatedResources.meta,
      ...fetchedResources.meta
    }

    updatedResources.items = updatedResources.items.concat(fetchedResources.items)
    setInnerResources(updatedResources)
  }

  return <View
    {...{ head, navbar, footer }}>
    {
      body.map((section, index) => {
        if (section.type === 'header') {
          return (
            <Header
              key={`podcast-${index}`}
              id={index}
              order={index}
              {...section.value}
            />
          )
        }
        if (section.type === 'resources') {
          return (
            <>
              <List
                key={`document-${index}`}
                resourceKind={KIND_AUDIO}
                fetchResources={fetchResources}
                backgroundColor={'bg-yellow-500'}
                backgroundIconColor={'text-yellow-600'}
                {...innerResources}
              />
              {
                innerResources.items.length < innerResources.meta.totalCount
                  ? (
                    <div
                      key={`button-${index}`}
                      className={
                        classNames([
                          'px-4',
                          'mb-20',
                          'w-full',
                          'm-auto',
                          'md:w-44'
                        ])
                      }>
                      <Button
                        outline
                        onClick={fetchResources}
                        pink
                      >
                        Ver más
                      </Button>
                    </div>
                  )
                  : ''
              }
            </>
          )
        }
        return null
      })
    }
    <Breadcrumb
      resourceKind={KIND_AUDIO}
      linkToKind />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.array,
  footer: PropTypes.object
}

export { getServerSideProps }
export default Home
